import appApi from '../../../../../api/app-api';
import { CheckStatusType } from '../../../../../api/types/students/payment-services/user-payments/user-payment-service-with-price-list';

export const updateCheckStatusOperation = async (
  paymentId: number,
  checkId: number,
  checkStatus: CheckStatusType,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);
    await appApi.updateCheckStatus(paymentId, checkId, checkStatus);
    setLoading(false);
  } catch (e) {
    setLoading(false);
    throw e;
  }
};
